module.exports = __webpack_public_path__ + "img/Belit-logo.2db119c2.png";